export default "__VITE_ASSET__CU2Fgd1Y__"